import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import { getMenu, GetMenuByUser } from "../../actions/menu.action";
import { redirectToLogin, revokeTokenUsers } from "../../actions/auth.action";
import { getEnterpriseByID } from "../../actions/enterprise.action";
import { invokeInterceptor } from "../../utils/UnauthorizedResponseInterceptor";
import AppBar from "@material-ui/core/AppBar";
import CssBaseline from "@material-ui/core/CssBaseline";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import HelpBar from "../AppBarMenu/helpBar.component";
import BuyBar from "../AppBarMenu/buyBar.component";
import MenuIcon from "@mui/icons-material/Menu";
import Tooltip from "@mui/material/Tooltip";
import SvgIcon from "@mui/material/SvgIcon"; 

import CarBuyBar from "../AppBarMenu/carBuyBar.component copy";
import { parseJwt } from "../../utils/userInfo";
import { isEmpty } from "../../utils/proprietaryHooks";
import AlertConfirm from "../../components/alertConfirm.component";
import PageBackground from "../pageBackground.component";
import {
  LeftMenu,
  // SuiteBar,
  UserMenu,
} from "@pif-tr-components/components";

import { Avatar, CircularProgress } from "@material-ui/core";
//import { useLocation } from "react-router";
import { IS_REFRESH_TOKEN } from "../../actions/types";
// import { border } from "@mui/system";
// import { Grid } from  '@material-ui/core';
import "./masterPage.css";

const MasterPage = ({
  component: Component,
  container,
  appName,
  isEmbedded,
  ...props
}) => {
  
  const [collapsedMenu, setCollapsedMenu] = useState({
    drawerWidth: window.innerWidth < 960 ? 44 : 260,
    collapsed: window.innerWidth < 960
  });
  const [collapsedMenuTitle, setCollapsedMenuTitle] = useState("Fijar menú");
  const handleMenuClick = () => {
    setCollapsedMenu({
      drawerWidth: collapsedMenu.collapsed ? 260 : 44,
      collapsed: !collapsedMenu.collapsed
    });
    setCollapsedMenuTitle(collapsedMenu.collapsed ? "Ocultar menú": "Fijar menú");
  };

  const useStyles = makeStyles((theme) => ({
    root: {
      display: "flex",
      //justifyContent: "center",
    },
    margin: {
      margin: theme.spacing(1),
    },
    drawer: {
      [theme.breakpoints.up("md")]: {
        width: collapsedMenu.drawerWidth,
        flexShrink: 0,
        position: collapsedMenu.collapsed ? "absolute":"relative",
        clip: "rect(0,45px,1500px,0)",
        /*borderRight: `${collapsedMenu.collapsed?"2":"0"}px solid #D6D6D6`,
        boxShadow: `0px 0px ${collapsedMenu.collapsed?"5":"0"}px 0px #a7a6a6`*/
      },
      [theme.breakpoints.down("sm")]: {
        width: "40px",
        flexShrink: 0,
        position: collapsedMenu.collapsed ? "absolute":"relative",
        clip: "rect(0,0px,1500px,0)"
      },
      width: "40px",
      marginRight: 10,
      zIndex: 3,
      /*"&:hover": {
        position: "relative",
        border: "3px solid red"
      },
      "&:has([role*='presentation']:hover)": {
        position: "relative",
      },*/
      "&:focus-within": {
        position: "relative",
      },
    },
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
      /*[theme.breakpoints.up("sm")]: {
        width: "100%",
      },*/
      //paddingLeft: "10px",
      paddingRight: "10px",
      background: "#F1F1F1 0% 0% no-repeat padding-box",
      width: "auto",
      left: "46px",
      [theme.breakpoints.down("sm")]: {
        left: collapsedMenu.collapsed ? "0px":"46px",
        paddingLeft: collapsedMenu.collapsed ? "46px":"0px"
      }
    },
    // necessary for content to be below app bar
    toolbar: theme.mixins.toolbar,
    content: {
      flexGrow: 1,
      padding: "0px",
      justifyContent: "flex-start",
      overFlowX: "hidden",
      width: "100%",
      [theme.breakpoints.up("md")]: {
        marginLeft: collapsedMenu.collapsed ? "45px":"0px",
      },
    },
    headerToolBar: {
      paddingLeft: "0px",
      paddingRight: "10px"
    },
    imageApp: {
      width: "163px",
      backgroundSize: "contain",
      backgroundRepeat: "no-repeat",
      height: "43px",
      backgroundImage: theme.logo.backgroundImage,
      paddingTop: "14px",
      flex: 1,
      marginLeft: "15px",
      cursor: "pointer"
    },
    userName: {
      fontSize: "14px",
      fontWeight: "bold",
      textAlign: "right",
      paddingRight: "8px",
      color: "#6D6E71",
      textTransform: "capitalize",
      alignItems: "center",
      display: "flex",
      [theme.breakpoints.down("xs")]: {
        fontSize: "10px",
      },
    },
    contentMenu: {
      flexDirection: "row",
      display: "flex",
      width: "85%",
      justifyContent: "flex-end",
    },
    iconGroup: {
      display: "flex",
      width: "400px",
      justifyContent: "flex-end",
    },
    constenAvatarName: {
      display: "flex",
      width: "auto",
      marginLeft: 10,
    },
    icon: {
      cursor: "pointer",
    },
    menuIcon: {
      zIndex: 1202,
      position: "absolute",
      color: "rgb(109, 110, 113)",
      paddingLeft: "15px",
      paddingTop: "25px",
      paddingRight: "5px",
      marginRight: "5px",
      cursor: "pointer",
      /*[theme.breakpoints.up("md")]: {
        height: collapsedMenu.collapsed ? "100%":"auto", 
        borderRight: `${collapsedMenu.collapsed?"2":"0"}px solid #D6D6D6`,
        boxShadow: `0px 0px ${collapsedMenu.collapsed?"5":"0"}px 0px #a7a6a6`
      },
      "&:hover": {
        height: "auto"
      },*/
    },
  }));

  const classes = useStyles();
  //const location = useLocation();
  const [token, setToken] = useState({
    result: {
      token: "",
    },
    error: {},
  });
  const currentAppName = "PIF";
  const [privileges, setPrivileges] = useState([]);
  const {
    history,
    privilegesAuthResponse,
    MessageRefreshToken,
    isRefreshToken,
    revokeTokenUsers,
  } = props;

  const [confirmMessage, setConfirmMessage] = useState({
    message: "",
    item: "",
    open: false,
  });

  const [isLoading, setLoading] = useState(true);
  const [user, setUser] = useState({ name: "", surname: "" });
  const userInfo = {
    user: {
      enterprise: "true",
      email: "",
      name: "",
      role: [""],
      profilePicture: "",
      closeSession: () => {
        closeSession();
      },
    },
  };
  const [changedLeftMenu, setChangedLeftMenu] = useState(false);
  const dispatch = useDispatch();

  //const appName = this.props.appName;
  invokeInterceptor(appName, history, dispatch);

  useEffect(() => {
    // setIsLoadingToken(true);
    getToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!isEmpty(MessageRefreshToken)) {
      setConfirmMessage({
        open: true,
        message: MessageRefreshToken,
        item: "RefreshTokenRevoked",
        textButtonAccept: "Aceptar",
      });
    }
  }, [MessageRefreshToken]);

  useEffect(() => {
    if (isRefreshToken) {
      // setIsLoadingToken(true);
      getToken();
      dispatch({
        type: IS_REFRESH_TOKEN,
        payload: false,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRefreshToken]);

  useEffect(() => {
    if (!isEmpty(privilegesAuthResponse)) {
      setConfirmMessage({
        open: true,
        message: privilegesAuthResponse,
        item: "auth",
        textButtonAccept: "Aceptar",
      });
    }
  }, [privilegesAuthResponse]);

  useEffect(() => {
    const tokenLocal = localStorage.getItem("jwtToken");
    if (tokenLocal) {
      const tokenClear = tokenLocal.replace("Bearer ", "");
      if (token.result) {
        if (token.result.token && token.result.token !== "") {
          if (tokenClear !== token.result.token) {
            localStorage.setItem("jwtToken", "Bearer " + token.result.token);
            localStorage.setItem("refreshToken", token.result.refreshToken);
            getToken(token.result.token);
            setChangedLeftMenu(true);
          }
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token.result.token]);

  useEffect(() => {
    if (changedLeftMenu) {
      setChangedLeftMenu(false);
    }
  }, [changedLeftMenu]);

  const getToken = (currentToken) => {
    let jwt;
    if (currentToken) {
      jwt = currentToken;
    } else {
      jwt = localStorage.getItem("jwtToken");
    }

    if (jwt) {
      const jwtToken = jwt.replace("Bearer ", "");
      const jwtPayload = parseJwt(jwt);
      setPrivileges(jwtPayload.PIF_PRIVILEGE);

      setUser({
        name: unescape(jwtPayload.given_name),
        surname: unescape(jwtPayload.family_name),
        enterprise: jwtPayload.customer_name,
        email: jwtPayload.email,
      });
      setToken((oldState) => ({
        ...oldState,
        result: {
          ...oldState.result,
          token: jwtToken,
        },
      }));

      setLoading(true);
      sleep(4000).then((r) => {
        dispatch(getEnterpriseByID(jwtPayload.customer_id));
        setLoading(false);
      });

      // setIsLoadingToken(false);
      return true;
    } else {
      setTimeout(getToken, 1000);
      return false;
    }
  };

  const sleep = (milliseconds) => {
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
  };

  const closeSession = () => {
    revokeTokenUsers();
  };

  if (isEmbedded) {
    return (
      <main className={classes.content}>
        <div className={classes.toolbar} />
        {token.result.token && user.name? (
          <Component
            user={user}
            isLoading={isLoading}
            Loading={setLoading}
            privileges={privileges}
            {...props}
          />
        ) : (
          <PageBackground />
        )}
      </main>
    );
  } else {
    return (
      <div className={classes.root}>
        <CssBaseline />
        <AppBar position="fixed" className={`${classes.appBar} 'App-Bar'`}>
          <Toolbar className={classes.headerToolBar}>
            {/* <Tooltip title="Inicio"> */}
              <div className={classes.imageApp} onClick={()=>{
                history.push("/monithor");
              }}></div>
            {/* </Tooltip> */}
            <div className={classes.contentMenu}>
              <div className={classes.iconGroup}>
                {true ? (
                  <div></div>
                ) : (
                  <div>
                    {" "}
                    <CarBuyBar></CarBuyBar>
                    <BuyBar></BuyBar>
                    <HelpBar></HelpBar>
                  </div>
                )}
                {/* <Grid>
                <SuiteBar appName="PIF" token={token.result.token} />
              </Grid> */}
                <div className={classes.constenAvatarName}>
                  <Typography
                    component={"span"}
                    className={classes.userName}
                    noWrap
                  >
                    {`${user.name} ${user.surname}`} <br />
                    {`${user.enterprise}`}
                  </Typography>
                  {token.result.token ? (
                    <UserMenu
                      key={"useMenu"}
                      appName={currentAppName}
                      userInfo={userInfo}
                      setTokens={setToken}
                      tokens={token}
                      functions={[]}
                      viewLoader={true}
                    />
                  ) : (
                    <Avatar>
                      {" "}
                      <CircularProgress color="secondary" size={20} />{" "}
                    </Avatar>
                  )}
                </div>

                {/* <NotificationBar></NotificationBar> */}
              </div>
            </div>
          </Toolbar>
        </AppBar>
        <div className={classes.menuIcon}>
          <Tooltip title={collapsedMenuTitle}>
            <SvgIcon
              className={classes.icon}
              component={MenuIcon}
              onClick={handleMenuClick}
            />
          </Tooltip>
        </div>
        <nav
          className={`${classes.drawer} custom-drawer `}
          aria-label="mailbox folders"
        >
          {token.result.token && !changedLeftMenu ? (
            <LeftMenu
              //style="width:60px"
              open={true}
              token={token.result.token}
              appName={currentAppName}
              drawerProps={{
                variant: "persistent",
                open: true, //!collapsedMenu.collapsed,
                //classes: {paper:{with:"50px"}},
              }}
              version="1.0.0"
              functions={[]}
            />
          ) : null}
        </nav>
        <main className={classes.content}>
          <div className={classes.toolbar} />
          {token.result.token ? (
            <Component
              user={user}
              isLoading={isLoading}
              Loading={setLoading}
              privileges={privileges}
              {...props}
            />
          ) : (
            <PageBackground />
          )}
        </main>
        <br/>
        {/* <div className={classes.content}>
          {"By Parameta"}
        </div> */}
        <div>
          <AlertConfirm
            isOpen={confirmMessage.open}
            modalMessage={confirmMessage.message}
            handleAccept={() => {
              if (confirmMessage.item === "sesion") {
                closeSession();
              } else if (confirmMessage.item === "RefreshTokenRevoked") {
                setConfirmMessage({
                  message: "",
                  item: "",
                  open: false,
                });

                closeSession();
              } else {
                ///cerrar load
                setConfirmMessage({
                  message: "",
                  item: "",
                  open: false,
                });

                //if (location.pathname === "/users") {
                //  history.go(0);
                // } else {
                //   history.push({
                //     pathname: "/users",
                //   });
                // }

                setLoading(false);

                dispatch({
                  type: "GET_PRIVILEGES_AUTH",
                  payload: {},
                });
              }
            }}
            showBtnAccept={true}
            showBtnCancel={false}
            textButtonAccept={confirmMessage.textButtonAccept}
            onCancel={true}
            onClose={() =>
              setConfirmMessage({
                message: "",
                item: "",
                open: false,
              })
            }
          />
        </div>
      </div>
    );
  }
};

MasterPage.propTypes = {
  getMenu: PropTypes.func.isRequired,
  container: PropTypes.any,
  //authReducer: PropTypes.func.isRequired,
  authReducer: PropTypes.any,
};

const mapStateToProps = (state) => ({
  menuReducer: state.menuReducer.getMenuResponse,
  getMenuByUserListResponse: state.menuReducer.getMenuByUserListResponse,
  isRevokeToken: state.authReducer.isRevokeToken,
  revokeTokenUsers: state.invoiceReducer,
  MessageRefreshToken: state.authReducer.MessageRefreshToken,
  privilegesAuthResponse: state.authReducer.privilegesAuthResponse,
  isRefreshToken: state.authReducer.isRefreshToken,
});

const mapDispatchToProps = {
  getMenu,
  redirectToLogin,
  revokeTokenUsers,
  GetMenuByUser,
  getEnterpriseByID,
};

export default connect(mapStateToProps, mapDispatchToProps)(MasterPage);
